import { useLang } from '@/context/LanguageContext';

export default function Marquee() {
  const { t } = useLang();
  return (
    <section className="overflow-hidden border-y border-white/10 bg-abyss/60 py-5" data-testid="marquee-section">
      <div className="marquee-track flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
            {t.marquee.map((item, i) => (
              <span key={i} className="flex items-center" data-testid={copy === 0 ? `marquee-item-${i}` : undefined}>
                <span className="whitespace-nowrap px-7 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-slate-500 sm:text-sm">
                  {item}
                </span>
                <span className="inline-block h-1.5 w-1.5 rotate-45 bg-pulse" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
